import { useDispatch, useSelector } from 'react-redux'
import { selectFlags } from '@Builder/QuoteDetailPage/selectors'
import { LeftOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Image from '~/core/Image'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { openChatDrift } from '~/redux-modules/drift'
import icons from '~/apps/consumer/icons'
import { mailtoLink } from '~/lib/mailtoLink'
import { HELP_EMAIL } from '~/lib/emailAndUrls'

import styles from './styles.css'

import { PLACEMENT } from '.'

const BUTTON_STYLE = { width: '160px' }

export default function OnBoardDrawerTitle({
    subMenuVisible,
    onClick,
    onClose,
}: {
    subMenuVisible: boolean
    onClick: () => void
    onClose: () => void
}) {
    const dispatch = useDispatch()
    const { disableDriftMessaging } = useSelector(selectFlags)

    const openChat = (evt: Event) => {
        evt.preventDefault()
        dispatch(openChatDrift())
        onClose()
    }

    return (
        <Box
            alignItems="center"
            backgroundColor="blackAlpha02"
            direction="col"
            padding="16px"
            position="relative"
        >
            {subMenuVisible && (
                <Link
                    data-test-target={`back-${PLACEMENT}`}
                    className={styles.backButton}
                    name="back"
                    onClick={(evt: Event) => {
                        evt.preventDefault()
                        onClick()
                    }}
                    placement={PLACEMENT}
                >
                    <LeftOutlined />
                    <Text fontSize="14px">Back</Text>
                </Link>
            )}
            <Image
                src={icons.fictors}
                style={{ marginTop: '32px' }}
                width="180px"
            />
            <Text
                fontWeight={500}
                fontSize="20px"
                style={{ lineHeight: '28px', marginTop: '8px' }}
            >
                Consult an expert
            </Text>
            <Text fontSize="12px" fontWeight={300} color="blackAlpha65">
                Available weekdays 9am - 6pm PST
            </Text>
            <Box marginTop="16px">
                {!disableDriftMessaging && (
                    <Button
                        data-test-target={`chat-${PLACEMENT}`}
                        name="chat-now"
                        onClick={openChat}
                        placement={PLACEMENT}
                        style={{ marginRight: '8px', ...BUTTON_STYLE }}
                    >
                        Chat now
                    </Button>
                )}
                <Button
                    data-test-target={`email-${PLACEMENT}`}
                    href={mailtoLink(HELP_EMAIL)}
                    target="_blank"
                    name="email-us"
                    placement={PLACEMENT}
                    style={BUTTON_STYLE}
                >
                    Email us
                </Button>
            </Box>
        </Box>
    )
}
